import { Link } from "react-router";
import { format, parseISO } from "date-fns";
import type { ExpenseDTO } from "@/lib/expenses";
import { CATEGORY_EMOJI, CATEGORY_COLOR } from "@/lib/categories";
import type { Category } from "@/lib/categories";
import { ScopeChip } from "@/components/scope-chip";
import { formatMoney } from "@/lib/format";

export function ExpenseCard({ expense }: { expense: ExpenseDTO }) {
  const color = CATEGORY_COLOR[expense.category as Category];

  return (
    <Link
      to={`/expense/${expense.id}`}
      className="flex items-center gap-3 px-4 py-3 transition-colors active:bg-muted/60"
    >
      <div
        className={`flex size-11 shrink-0 items-center justify-center rounded-full text-xl ${color?.tint ?? "bg-zinc-100"}`}
      >
        {CATEGORY_EMOJI[expense.category]}
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-1.5">
          <p className="truncate font-semibold leading-tight">
            {expense.merchant}
          </p>
          <ScopeChip scope={expense.scope} />
        </div>
        <p className="truncate text-xs text-muted-foreground">
          {expense.category} · {format(parseISO(expense.date), "EEE, MMM d")}
          {expense.odometer != null && ` · ${expense.odometer.toLocaleString()} km`}
        </p>
      </div>
      <div className="shrink-0 text-right font-semibold tabular-nums">
        {formatMoney(expense.totalCents, expense.currency)}
      </div>
    </Link>
  );
}
